import React from 'react'
import { Button } from 'rsuite'
import Icon from './Icon'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { getFavourites } from '../redux/options/selectors'
import { setFavourites } from '../redux/options/actions'

// tools
import { isFavourite, addFavourite, removeFavourite } from '../tools/Favourites'

/**
 * Add a car to the favourites or remove it: an open star to add, a full star to remove
 * @param {Object} props component props
 * @param {number|string} props.car start number
 * @returns {JSX.Element|null} button, nothing without a car
 */
const FavouriteButton = ( { car = 0 } ) =>
{
  const favourites = useSelector( getFavourites )
  const dispatch = useDispatch()

  if ( !car ) return null

  const favourite = isFavourite( car, favourites )

  /**
   * Add the car to the favourites, or remove it
   * @returns {void}
   */
  const onClick = () => dispatch( setFavourites(
    favourite ? removeFavourite( favourites, car ) : addFavourite( favourites, car )
  ) )

  return (
    <Button onClick={ onClick } className="favourite-button">
      <Icon icon="star" className={ favourite ? '' : 'open' }/> <span className="label">{ favourite ? 'Remove favourite' : 'Add favourite' }</span>
    </Button>
  )
}

export default FavouriteButton
